module.exports = __webpack_public_path__ + "static/media/mapa3.19e65b06.png";